import { render } from "./transferFoodModel.vue?vue&type=template&id=164129d6"
import script from "./transferFoodModel.vue?vue&type=script&lang=js"
export * from "./transferFoodModel.vue?vue&type=script&lang=js"

import "./transferFoodModel.vue?vue&type=style&index=0&id=164129d6&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__